import React, {useState,useEffect} from 'react';
import { Form, InputGroup, Button} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons";
import ListGroup from 'react-bootstrap/ListGroup'; 
import {faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import Rightbar from './Rightbar';
import {Link, useParams,useNavigate} from 'react-router-dom';
import {listVirtualBooth} from '../../Service';
import Swal from "sweetalert2";

export default function YourProgramming(){ 
   const params = useParams();
   const [sidebar, setsidebar] = useState(false);
   const [mainbar, setmainbar] = useState(false);
   const [virtualBooth,getVirtualBooth] = React.useState([]);
   const [formErrors, setFormErrors] = useState({});
   const toggle = () => {
        setsidebar(!sidebar);
        setmainbar(!mainbar);
   }

   useEffect(() => {
      let paramsDt={payment_id:params.id}
      listVirtualBooth(paramsDt).then(res => setHandleResponse(res))
     },[]);
   
   const setHandleResponse = (response) => 
   {
      if(response.data.code==200){  
         getVirtualBooth(response.data.data.item);
      } else {
         const errors = {};
           Swal.fire({
             icon: 'error',
             title: 'Oops...',
             text: response.data.message,
           })
      }
   }

   console.log('virtualbooth',virtualBooth);
return(
   <>
   <section className="sec-container" >
      <div className='container'>
         <div className='portalevent'>
            <div className='row'>
               <div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
                  <div >
                     <Rightbar/>
                  </div>
               </div>
               <div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
                  <div className='rightbar  virtual'>
                     <Button variant="outline-info" onClick={toggle}>
                     <FontAwesomeIcon icon={faAlignLeft} />
                     </Button>
            
                     <h1>Virtual Booths</h1>
                     {
                        virtualBooth.length ?
                        virtualBooth.map( data => (
                           <div className='program-row'>
                              <div className='row'>                                 
                                 <div className='col-md-6 ' >
                                    <h3>{data.booth_nickname}</h3> 
                                 </div>
                                 <div className='col-md-6 middle-aln'>
                                    <Link to={`/ViewBooth/${data.id}`}><Button className='common-btn'>View booth</Button>{' '}</Link>
                                    <Link to={`/editvirtualbooth/${data.id}`}><Button className='cancel-btn'>Edit booth</Button>{' '}</Link>
                                 </div>
                              </div>
                           </div>
                        )) : ''
                     }
                     

                     
                     <br/>
                     <div className='text-center'>
                     <Link to={`/createvirtualbooth/${params.id}`}><Button className='common-btn'>Create booth</Button></Link>{' '}
                     </div>

                  </div>
               </div>
            </div>
         </div>
      </div>
   </section>  
   </>
)
}
